import React from "react";
import { Action, IOWidget, mk_widget } from "widgets-for-react";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import moment, { Moment } from "moment";
import { isLinkExternalDomain } from "../../../../cms/blocks/utils.gen";
import { NavLink } from "react-router-dom";
import { get_wordpress_lang, toRelativeUrl } from "../../../../../utils";

// TimeLine stepp
export interface TimeLineStep {
  label: Moment;
  title: string;
  image_url: string;
  image_id: number;
  has_link: boolean;
  link_url?: string;
  link_text?: string;
}

// The main time line component
export type TimeLineBlockProps<CustomBlockData, extra_images> = {
  title?: string;
  intro?: string;
  blocks: TimeLineStep[];
};

export type TimeLineBlockStyle = Partial<{}>;

export function TimeLineBlock<CustomBlockData, extra_images>(
  props: TimeLineBlockProps<CustomBlockData, extra_images>,
  options?: { style?: TimeLineBlockStyle; key?: string }
): IOWidget<
  CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>,
  Action<CMSState<CustomBlockData, extra_images, never>>
> {
  return (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: () => {
        return (
          <section className="block block--timeline">
            <div className="block__inner container container--l grid--block">
              {(props.title || (props.intro && props.intro != "<p></p>")) && (
                <header className="block__header container container--s">
                  {props.title && <h2 className="block__title typo--3xl">{props.title}</h2>}
                  {props.intro && props.intro != "<p></p>" && <div className="block__intro" dangerouslySetInnerHTML={{ __html: props.intro }} />}
                </header>
              )}
              <div className="block__content">
                <ul className="block__list">
                  {props.blocks.sort((a, b) => a.label.diff(b.label)).map(StepRenderer)}
                </ul>
              </div>
            </div>
          </section>
        );
      },
    });
}

const format_date_safe = (m: moment.Moment) => moment.isMoment(m) ? m.locale(get_wordpress_lang()).format("MMMM YYYY") : m

const StepRenderer = (step: TimeLineStep) => {
  return (
    <li className="block__item item">
      {step.has_link ? (
        isLinkExternalDomain(step.link_url) ? (
          <a className="item__link" target="_blank" href={step.link_url}>
            <div className="item__inner">
              {step.label && <time className="item__date typo--3xs" dateTime={format_date_safe(step.label)}>
                {format_date_safe(step.label)}
              </time>}
              {step.title && <h3 className="item__title typo--s">{step.title}</h3>}
              <div className="item__fauxlink typo--2xs">
                <span>{window.wp.language == 'en' ? 'Read more' : 'Lees meer'}</span>
                <svg width="11" height="11" aria-hidden="true" className="item__icon">
                  <use xlinkHref="#link--external" />
                </svg>
              </div>
              {step.image_id && <div className="item__visual">
                <img src={step.image_url} alt={step.image_id.toString()} />
              </div>}
            </div>
          </a>
        ) : (
            <NavLink className="item__link" to={toRelativeUrl(step.link_url)}>
              <div className="item__inner">
                {step.label && (
                  <time className="item__date typo--3xs" dateTime={format_date_safe(step.label)}>
                    {format_date_safe(step.label)}
                  </time>
                )}
                {step.title && <h3 className="item__title typo--s">{step.title}</h3>}
                {step.image_url && (
                  <div className="item__visual">
                    <img src={step.image_url} alt={step.image_id.toString()} />
                  </div>
                )}
              </div>
            </NavLink>
          )
      ) : (
          <div className="item__inner">
            {step.label && (
              <time className="item__date typo--3xs" dateTime={format_date_safe(step.label)}>
                {format_date_safe(step.label)}
              </time>
            )}
            {step.title && <h3 className="item__title typo--s">{step.title}</h3>}
            {step.image_url && (
              <div className="item__visual">
                <img src={step.image_url} alt={step.image_id.toString()} />
              </div>
            )}
          </div>
        )}
    </li>
  );
};
